module.exports = __webpack_public_path__ + "static/media/log_in.bba8fffb.jpg";